module.exports = __webpack_public_path__ + "img/product_bg_new_02.e3a23ce.svg";